(() => {
  if (window.__stampAttributionLoaded) return;
  window.__stampAttributionLoaded = true;

  const valid = (value) =>
    typeof value === "string" && /^[A-Za-z0-9_-]{32}$/.test(value);

  const storageKey = "smb_checkout_ref_v1";
  let reference = new URL(window.location.href).searchParams.get("smb_ref");

  try {
    if (valid(reference)) {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          reference,
          expires: Date.now() + 86400000,
        }),
      );
    } else {
      const saved = JSON.parse(
        sessionStorage.getItem(storageKey) || "null",
      );

      reference =
        saved?.expires > Date.now() && valid(saved.reference)
          ? saved.reference
          : null;
    }
  } catch {}

  const root = window.Shopify?.routes?.root || "/";

  const privacyAllowed = () => {
    const privacy = window.Shopify?.customerPrivacy;

    return (
      privacy?.marketingAllowed?.() === true &&
      privacy?.saleOfDataAllowed?.() === true
    );
  };

  function addProperty(form, name, value) {
    let input = form.querySelector(`input[name="properties[${name}]"]`);

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${name}]`;
      form.appendChild(input);
    }

    input.value = value;
  }

  function updateForms() {
    if (!valid(reference)) return;

    document
      .querySelectorAll('form[action*="/cart/add"]')
      .forEach((form) => {
        addProperty(form, "_smb_ref", reference);
        addProperty(
          form,
          "_smb_ads_consent",
          String(privacyAllowed()),
        );
      });
  }

  let writing = Promise.resolve();

  function persist() {
    updateForms();

    writing = writing
      .catch(() => {})
      .then(async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 2500);

        try {
          await fetch(`${root}cart/update.js`, {
            method: "POST",
            credentials: "same-origin",
            signal: controller.signal,
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              attributes: {
                ...(valid(reference)
                  ? { smb_ref: reference }
                  : {}),
                smb_ads_consent: String(privacyAllowed()),
              },
            }),
          });
        } finally {
          clearTimeout(timeout);
        }
      })
      .catch(() => {});

    return writing;
  }

  function start() {
    if (valid(reference)) void persist();

    const observer = new MutationObserver(updateForms);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    document.addEventListener(
      "visitorConsentCollected",
      () => {
        void persist();
      },
    );

    document.addEventListener("submit", updateForms, true);

    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures(
        [
          {
            name: "consent-tracking-api",
            version: "0.1",
          },
        ],
        (error) => {
          if (!error && valid(reference)) void persist();
        },
      );
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {
      once: true,
    });
  } else {
    start();
  }
})();